<div class="row">
  <div class="col-md-12">
    <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
      <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
        <mat-card-title class="mat-mdc-card-title text-white">
          {{ 'DisplayPriceForClient'|translate }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="mat-mdc-card-content text-center">
        <div class="m-t-20" *ngFor="let cost of DisplayPriceData">
          <div class="row">
            <div class="col-md-2 justify-content-center">
              <img class="m-auto ms-5 product-img"
                   src="{{cost.subCategoryImage | adjust_image_path }}">
            </div>
            <div class="col-md-9">
              <span class="TypeName"> {{ cost.typeName }}</span>

              <table class="table w-100 m-b-20">
                <tr>
                  <td>
                                        <span class="span-title">{{ 'Color' | translate }} :
                                        </span>
                    <span>{{ cost.colorName }} </span>
                  </td>
                  <td>
                                        <span class="span-title">{{ 'Length' | translate }} :
                                        </span>
                    <span>{{ cost.height }} {{ 'Meter' | translate }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                                        <span class="span-title"> {{ 'width' | translate }} :
                                        </span>
                    <span>{{ cost.width }} {{ 'Meter' | translate }}</span>
                  </td>
                  <td>
                    <span class="span-title">{{ 'NumberOfMeters' | translate }} : </span>
                    <span>{{ ClacNumberOfMeters(cost.width, cost.height) }}
                      {{ 'squareMeter'|translate }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="span-title">{{ 'Price' | translate }} : </span>
                    <span>{{ cost.price ?? 1 }} {{ 'EGP'|translate }}</span>
                  </td>
                </tr>
              </table>

              <span class="AddedToPrice" *ngIf="cost?.AdditionalDetails?.length!=0">
                                {{ 'AddedToPrice' | translate }} :
                            </span>

              <div class="row m-t-20 m-b-20">
                <div class="col-md-6" *ngFor="let details of cost?.AdditionalDetails">
                  <app-display-details [OnlyValue]="details?.value!=null"
                                       [data]="details"></app-display-details>
                </div>
              </div>
              <div *ngIf="cost?.AdditionalDetails?.length!=0">
                <mat-divider></mat-divider>
                <span>{{ 'TotalAdditions'|translate }} : </span>
                <span>{{ ClacAllAdditions() }} {{ 'EGP'|translate }}</span>
              </div>
            </div>
          </div>
          <div class="tblTitle">
            <span>{{ 'TotalCost' | translate }} : </span>
            <span *ngIf="cost?.AdditionalDetails?.length!=0">
                            {{ GetCost(cost) }} * {{ cost.count ?? 1 }} + {{ ClacAllAdditions() }} =
              {{ ClacTotalCost(cost, true) }}
              {{ 'EGP'|translate }}
                        </span>

            <span *ngIf="cost?.AdditionalDetails?.length==0">
                            {{ GetCost(cost) }} * {{ cost.count ?? 1 }} =
              {{ ClacTotalCost(cost, false) }}
              {{ 'EGP'|translate }}
                        </span>
          </div>
        </div>
        <div class="row m-t-24">
          <div class="col-sm-12">
            <div class="calc-cost-actionbar">
              <button class="btn orangecolorbtn" (click)="SaveDisplayPrice()">
                {{ 'SaveDisplayPrice'|translate }}
              </button>

              <button class="btn colorbtn" (click)="SendWhatsAppMessage()">
                {{ 'SendToWhatsApp'|translate }}
              </button>

              <button class="btn orangecolorbtn" (click)="exportPDF()">
                {{ 'exportPDF'|translate }}
              </button>

              <button mat-button class="btn btnClose" (click)="Cancel()"> {{ 'Back' | translate }}</button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
